<div id="tophome"></div>
@if (isMobileViewport && !isLoggedIn) {
  <div class="mobile-auth-host" aria-hidden="true">
    <app-headermain></app-headermain>
  </div>
}
<div class="header-mobile">
    <nav class="mobile-nav">
      <div class="mobile-item-cntnr">
        <a [href]="navLinks.buses">
          <div class="mobile-item" [class.selected]="activeTab === 'bus'" data-index="2">
              <div class="mobile-icon ixi-icon-bus-home">
                  <i class="fa fa-bus" aria-hidden="true"></i>
              </div>
              <div class="mobile-text">BUSES</div>
          </div>
        </a>
      </div>
        <div class="mobile-item-cntnr">
          <a [href]="navLinks.trains" rel="noreferrer" target="_blank">
            <div class="mobile-item" [class.selected]="activeTab === 'train'" data-index="3">
                <div class="mobile-icon ixi-icon-train-home train-icon">
                    <i class="fa fa-subway" aria-hidden="true"></i>

                </div>
                <div class="mobile-text">TRAINS</div>
            </div>
          </a>
        </div>
        <div class="mobile-item-cntnr">
          <a [href]="navLinks.flights" rel="noreferrer" >
            <div class="mobile-item" [class.selected]="activeTab === 'flight'" data-index="0">
                <div class="mobile-icon ixi-icon-flight-home flight-icon">
                    <i class="fa fa-plane" aria-hidden="true"></i>
                </div>
                <div class="mobile-text">FLIGHTS</div>
            </div>
          </a>
        </div>
        <div class="mobile-item-cntnr">
          <a [href]="navLinks.hotels" rel="noreferrer">
            <div class="mobile-item" [class.selected]="activeTab === 'hotel'" data-index="0">
                <div class="mobile-icon product-icon ixi-icon-hotel-home hotel-icon">
                    <i class="fa fa-building" aria-hidden="true"></i>
                </div>
                <div class="mobile-text">HOTELS</div>
            </div>
          </a>
        </div>
        <div class="mobile-item-cntnr">
          <a href="#" (click)="handleAccountClick($event)">
            <div class="mobile-item" [class.selected]="activeTab === 'account'" data-index="4">
                <div class="mobile-icon mobile-account-icon">
                    <i class="fa" [ngClass]="isLoggedIn ? 'fa-user-circle' : 'fa-sign-in-alt'" aria-hidden="true"></i>
                </div>
                <div class="mobile-text">{{ isLoggedIn ? 'ACCOUNT' : 'MANAGE MY ACCOUNT' }}</div>
            </div>
          </a>
        </div>
        <div class="nav-border"></div>
    </nav>
</div>
